import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { instanceOf, string, func } from 'prop-types';
import SEO from 'Jsx/Shared/SEO';

import {
  toggleFilterCategory,
  clearAllFilters,
} from 'Jsx/Catalog/components/FiltersV2/redux/actions';

import { setDefaultOrderBy } from 'Jsx/Catalog/components/OrderByV2/redux/actions';

import { clearSearch } from 'Jsx/Catalog/components/SearchLanding/redux/actions';

import { getBreadcrumbs, getMetaTitle } from './redux/Selectors';

const BreadcrumbsContainer = styled.div`
  margin: auto;
  display: none;

  @media (min-width: 1140px) {
    display: block;
    width: 100%;
  }
`;

class Breadcrumbs extends React.Component {
  getBreadcrumbsWithOnClickHandlers = () => {
    const {
      breadcrumbs,
      clearAllFilters: clearAllFiltersAction,
      toggleFilterCategory: toggleFilterCategoryActions,
      setDefaultOrderBy: setDefaultOrderByAction,
      clearSearch: clearSearchAction,
      search,
    } = this.props;

    const courses = breadcrumbs.get('courses');
    // const orderBy = breadcrumbs.get('orderBy');
    const category = breadcrumbs.get('category');
    const subCategory = breadcrumbs.get('subCategory');

    breadcrumbs.set('courses', {
      ...courses,
      onClick: () => {
        // remove both filters and orderBy
        setDefaultOrderByAction();
        clearAllFiltersAction();
        clearSearchAction();
        if (window.clearTextValue) window.clearTextValue();
      },
    });

    if (!search) {
      if (category) {
        breadcrumbs.set('category', {
          ...category,
          // subItemId to zero because it is the "Todos <category name>" option
          onClick: () =>
            toggleFilterCategoryActions({ itemId: category.id, subItemId: 0 }),
        });
      }

      if (subCategory) {
        breadcrumbs.set('subCategory', {
          ...subCategory,
          onClick: setDefaultOrderByAction,
        });
      }
    }

    return Array.from(breadcrumbs.values());
  };

  render() {
    const { metaTitle } = this.props;
    const breadCrumbsItems = this.getBreadcrumbsWithOnClickHandlers();

    return (
      <div style={{ width: '100%' }}>
        <BreadcrumbsContainer>
          <SEO fontSize={12} breadcrumbs={breadCrumbsItems} title={metaTitle} />
        </BreadcrumbsContainer>
      </div>
    );
  }
}

Breadcrumbs.defaultProps = {
  search: null,
};

Breadcrumbs.propTypes = {
  breadcrumbs: instanceOf(Map).isRequired,
  metaTitle: string.isRequired,
  toggleFilterCategory: func.isRequired,
  clearAllFilters: func.isRequired,
  setDefaultOrderBy: func.isRequired,
  clearSearch: func.isRequired,
  search: string,
};

const mapStateToProps = state => {
  const breadcrumbs = getBreadcrumbs(state);
  const metaTitle = getMetaTitle(state, breadcrumbs);

  return {
    breadcrumbs,
    metaTitle,
    search: state.search.value,
  };
};

export default connect(mapStateToProps, {
  setDefaultOrderBy,
  toggleFilterCategory,
  clearAllFilters,
  clearSearch,
})(Breadcrumbs);
